import { createSlice } from '@reduxjs/toolkit';

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    telegram: null,
    email: null,
    emailNotice: '',

    isEmailTelegram: false,
    isFormTelegram: false,
    isCartTelegram: false,
    isLinkTelegram: false,
    isContactTelegram: false,
    isCartAddTelegram: false,

    isDigitalTelegram: false,
    isAppointmentTelegram: false,
    isEventsTelegram: false,
    isRequestTelegram: false,
    isDonationTelegram: false,

    isMailEmail: false,
    isFormEmail: false,
    isCartEmail: false,
    isLinkEmail: false,
    isContactEmail: false,
    isCartAddEmail: false,

    isDigitalEmail: false,
    isAppointmentEmail: false,
    isEventsEmail: false,
    isRequestEmail: false,
    isDonationEmail: false,
  },
  reducers: {
    notificationUpdateTelegram: (state, action) => {
      state.telegram = action.payload;
    },
    notificationUpdateEmail: (state, action) => {
      state.email = action.payload;
    },
    notificationUpdateEmailNotice: (state, action) => {
      state.emailNotice = action.payload;
    },
    notificationUpdateIsEmailTelegram: (state, action) => {
      state.isEmailTelegram = action.payload;
    },
    notificationUpdateIsFormTelegram: (state, action) => {
      state.isFormTelegram = action.payload;
    },
    notificationUpdateIsCartTelegram: (state, action) => {
      state.isCartTelegram = action.payload;
    },
    notificationUpdateIsLinkTelegram: (state, action) => {
      state.isLinkTelegram = action.payload;
    },
    notificationUpdateIsContactTelegram: (state, action) => {
      state.isContactTelegram = action.payload;
    },
    notificationUpdateIsCartAddTelegram: (state, action) => {
      state.isCartAddTelegram = action.payload;
    },
    notificationUpdateIsDigitalTelegram: (state, action) => {
      state.isDigitalTelegram = action.payload;
    },
    notificationUpdateIsAppointmentTelegram: (state, action) => {
      state.isAppointmentTelegram = action.payload;
    },
    notificationUpdateIsEventsTelegram: (state, action) => {
      state.isEventsTelegram = action.payload;
    },
    notificationUpdateIsRequestTelegram: (state, action) => {
      state.isRequestTelegram = action.payload;
    },
    notificationUpdateIsDonationTelegram: (state, action) => {
      state.isDonationTelegram = action.payload;
    },
    notificationUpdateIsMailEmail: (state, action) => {
      state.isMailEmail = action.payload;
    },
    notificationUpdateIsFormEmail: (state, action) => {
      state.isFormEmail = action.payload;
    },
    notificationUpdateIsCartEmail: (state, action) => {
      state.isCartEmail = action.payload;
    },
    notificationUpdateIsLinkEmail: (state, action) => {
      state.isLinkEmail = action.payload;
    },
    notificationUpdateIsContactEmail: (state, action) => {
      state.isContactEmail = action.payload;
    },
    notificationUpdateIsCartAddEmail: (state, action) => {
      state.isCartAddEmail = action.payload;
    },
    notificationUpdateIsDigitalEmail: (state, action) => {
      state.isDigitalEmail = action.payload;
    },
    notificationUpdateIsAppointmentEmail: (state, action) => {
      state.isAppointmentEmail = action.payload;
    },
    notificationUpdateIsEventsEmail: (state, action) => {
      state.isEventsEmail = action.payload;
    },
    notificationUpdateIsRequestEmail: (state, action) => {
      state.isRequestEmail = action.payload;
    },
    notificationUpdateIsDonationEmail: (state, action) => {
      state.isDonationEmail = action.payload;
    },
  },
});

export const {
  notificationUpdateTelegram,
  notificationUpdateEmail,
  notificationUpdateEmailNotice,
  notificationUpdateIsEmailTelegram,
  notificationUpdateIsFormTelegram,
  notificationUpdateIsCartTelegram,
  notificationUpdateIsLinkTelegram,
  notificationUpdateIsContactTelegram,
  notificationUpdateIsCartAddTelegram,
  notificationUpdateIsDigitalTelegram,
  notificationUpdateIsAppointmentTelegram,
  notificationUpdateIsEventsTelegram,
  notificationUpdateIsRequestTelegram,
  notificationUpdateIsDonationTelegram,
  notificationUpdateIsMailEmail,
  notificationUpdateIsFormEmail,
  notificationUpdateIsCartEmail,
  notificationUpdateIsLinkEmail,
  notificationUpdateIsContactEmail,
  notificationUpdateIsCartAddEmail,
  notificationUpdateIsDigitalEmail,
  notificationUpdateIsAppointmentEmail,
  notificationUpdateIsEventsEmail,
  notificationUpdateIsRequestEmail,
  notificationUpdateIsDonationEmail,
} = notificationSlice.actions;

export const selectNotificationTelegram = (state) => state.notification.telegram;
export const selectNotificationEmail = (state) => state.notification.email;
export const selectNotificationEmailNotice = (state) => state.notification.emailNotice;
export const selectNotificationIsEmailTelegram = (state) => state.notification.isEmailTelegram;
export const selectNotificationIsFormTelegram = (state) => state.notification.isFormTelegram;
export const selectNotificationIsCartTelegram = (state) => state.notification.isCartTelegram;
export const selectNotificationIsLinkTelegram = (state) => state.notification.isLinkTelegram;
export const selectNotificationIsContactTelegram = (state) => state.notification.isContactTelegram;
export const selectNotificationIsCartAddTelegram = (state) => state.notification.isCartAddTelegram;
export const selectNotificationIsDigitalTelegram = (state) => state.notification.isDigitalTelegram;
export const selectNotificationIsAppointmentTelegram = (state) => state.notification.isAppointmentTelegram;
export const selectNotificationIsEventsTelegram = (state) => state.notification.isEventsTelegram;
export const selectNotificationIsRequestTelegram = (state) => state.notification.isRequestTelegram;
export const selectNotificationIsDonationTelegram = (state) => state.notification.isDonationTelegram;
export const selectNotificationIsMailEmail = (state) => state.notification.isMailEmail;
export const selectNotificationIsFormEmail = (state) => state.notification.isFormEmail;
export const selectNotificationIsCartEmail = (state) => state.notification.isCartEmail;
export const selectNotificationIsLinkEmail = (state) => state.notification.isLinkEmail;
export const selectNotificationIsContactEmail = (state) => state.notification.isContactEmail;
export const selectNotificationIsCartAddEmail = (state) => state.notification.isCartAddEmail;
export const selectNotificationIsDigitalEmail = (state) => state.notification.isDigitalEmail;
export const selectNotificationIsAppointmentEmail = (state) => state.notification.isAppointmentEmail;
export const selectNotificationIsEventsEmail = (state) => state.notification.isEventsEmail;
export const selectNotificationIsRequestEmail = (state) => state.notification.isRequestEmail;
export const selectNotificationIsDonationEmail = (state) => state.notification.isDonationEmail;

export default notificationSlice.reducer;
